import { Asterisk } from "lucide-react";

export const Marquee = ({ items, testid = "editorial-marquee" }) => {
  const row = [...items, ...items];
  return (
    <div className="overflow-hidden border-y border-white/5 bg-[#0C0E0D] py-8 select-none" data-testid={testid}>
      <div className="marquee-track items-center gap-10 pr-10">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10 whitespace-nowrap">
            <span className="font-display italic text-3xl md:text-4xl text-zinc-200">{item}</span>
            <Asterisk size={22} className={i % 2 === 0 ? "text-lime-400" : "text-purple-400"} />
          </span>
        ))}
      </div>
    </div>
  );
};
